import React, { useState } from "react";

import { TableAccessModal } from "@/components/common/modals/table-access-modal";

import { ContextMenuItem } from "@/components/ui/context-menu";

interface Props extends React.ComponentProps<"div"> {
  rightClickedElement: HTMLElement;
}

/**
 * Keeps link access configuration consistent with table rules.
 */
const LinkContextActions: React.FC<Props> = ({ rightClickedElement }) => {
  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);

  const linkElement =
    (rightClickedElement.closest("a") as HTMLElement | null) ??
    rightClickedElement;
  const elementId = linkElement?.id ?? "";

  return (
    <>
      <ContextMenuItem
        className="flex items-center justify-between"
        onSelect={(event) => {
          event.preventDefault();
          if (!linkElement) return;
          setIsAccessModalOpen(true);
        }}
      >
        دسترسی
      </ContextMenuItem>

      <TableAccessModal
        isOpen={isAccessModalOpen}
        tableId={elementId}
        table={linkElement}
        title="مدیریت دسترسی لینک"
        showColumns={false}
        onClose={() => setIsAccessModalOpen(false)}
      />
    </>
  );
};

export default LinkContextActions;
